import { RootState } from "app/store";
import { EControlType } from "components/ControlWrapper";
import { IGridItem } from "components/controls/CustomDetailList/IGridItem";
import { friendlyValue } from "global/Application";
import { AppDataSource } from "global/DataSources/AppDataSource";
import { IFlexibleField } from "model/FlexibleAttributeModel";
import { EColumnExtractDataTypes } from "./EColumnExtractDataTypes";
import { IColumnExtract } from "./IColumnExtract.type";
import { IDatasetExtract } from "./IDatasetExtract";
import { IRowExtract } from "./IRowExtract.type";

interface IRowExtractExtended extends IRowExtract {
    [key: string]: string | undefined | { value: string, format: string } | any;
}

export default async function DetailListExcelGeneration(
    state: RootState,
    dataSource: AppDataSource,
    columns: IColumnExtract[],
    items: any[]

) {
    const reportRows: IRowExtractExtended[] = [];
    const reportColumns: Record<string, IColumnExtract> = {};
    let columnIX = 0;
    const config = state.data.config;

    // first column
    columns.forEach(eachColumn => {
        reportColumns[eachColumn.fieldName] = {
            attributeId: '',
            order: 0,
            width: 35,
            index: ++columnIX,
            fieldName: eachColumn.fieldName,
            hidden: false,
            name: eachColumn.name,
            dataType: EColumnExtractDataTypes.Default,
        };
    })

    items.forEach((item: IGridItem, ix) => {

        // does the item provide to extract implementation ?
        if (item.toExtract) {
            const reportRow: IRowExtractExtended = item.toExtract();
            if (reportRow)
                reportRows.push(reportRow);
            
            return;

        } else {
            // use default implementation
            const reportRow: IRowExtractExtended = {};

            reportRow['name'] = item.name;

            item.data.fields.forEach((eachField: IFlexibleField) => {

                const configAttribute = state.data.config.cache.map_bcbs_config_attribute[eachField.configRef.id];
                const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

                // lets always get the first one
                // verified with William there will never be a Tier/PCP/Specialist mode for these.
                eachField.values.forEach(eachFieldValue => {
                    const key = `${configAttribute.bcbs_config_attributeid}-${eachFieldValue?.tierRef?.id ?? ''}`;

                    if (eachFieldValue.value)
                        reportRow[key] = friendlyValue(
                            masterAttribute.bcbs_attributetypecode as EControlType,
                            eachFieldValue.value
                        );
                });
            })

            reportRows.push(reportRow);
        }

    })

    const columnsArray = Object.entries(reportColumns).map(kv => kv[1]).sort((a, b) => a.order - b.order);

    const dataSet: IDatasetExtract = {
        name: '',
        tables: [
            {
                columns: columnsArray,
                data: reportRows,
                name: "Extract"
            }
        ],
        dropDownTables: null
    }

    const getNonstandardExtractAsync = await dataSource.getGenerateExcelExtract(dataSet);
    return getNonstandardExtractAsync;

}